import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { customerDataGridActions, customerSelector } from '../';

const useClient = () => {
  const clients = useSelector(state =>
    customerSelector.getCustomerListTransformed(state),
  );
  const clientFilters = useSelector(state =>
    customerSelector.getCustomerFilters(state),
  );
  const rawClients = useSelector(state =>
    customerSelector.getCustomerListRaw(state),
  );
  const dispatch = useDispatch();
  const forceRefresh = useSelector(state =>
    customerSelector.getForceRefresh(state),
  );

  useEffect(() => {
    if (clients.length < 1 || (clients.length > 0 && forceRefresh)) {
      dispatch(
        customerDataGridActions.fetchGridList({ filters: clientFilters }),
      );
    }
  }, [clients.length, clientFilters, dispatch, forceRefresh]);

  return { clients, rawClients };
};

export default useClient;
